/**
 * @param {ReduxState} state - The Redux state.
 * @returns {FeaturedHeadToHeadState} The Featured Head To Head state.
 */
export const featuredHeadToHeadSelector = (state) =>
    state.statspro.featuredHeadToHead;
